import { render, staticRenderFns } from "./messageModal.vue?vue&type=template&id=0141c404&"
import script from "./messageModal.vue?vue&type=script&lang=js&"
export * from "./messageModal.vue?vue&type=script&lang=js&"
import style0 from "./messageModal.vue?vue&type=style&index=0&id=0141c404&lang=scss&"


/* normalize component */
import normalizer from "!../../../integrationtest/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0141c404')) {
      api.createRecord('0141c404', component.options)
    } else {
      api.reload('0141c404', component.options)
    }
    module.hot.accept("./messageModal.vue?vue&type=template&id=0141c404&", function () {
      api.rerender('0141c404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pointshop-widget/src/components/messageModal.vue"
export default component.exports